export const globalOption = {
  title: {
    text: ' '
  },
  subtitle: {
    text: ' '
  },
  exporting: {
    enabled: false
  },
  chart: {
    type: 'column',
    polar: false,
    backgroundColor: '#fff',
    height: null,
    inverted: false
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        formatter: function () {
          return this.y > 0 ? this.y.toLocaleString() : undefined
        }
      }
    },
    column: {
      // set stacking to undefined to fix the stacking behaviour of bar charts in step 5.
      // still need to check if there's any other graph affeccted by this change.
      stacking: undefined,
      dataLabels: {
        style: {
          color: '#333',
          fontWeight: 'normal'
        },
        enabled: true,
        inside: false
      }
    }
  },
  credits: {
    enabled: false
  },
  colors: ['#FFBA87', '#e1823c', '#87BFFF', '#6799d2', '#8DD872', '#46AB21'],
  pane: {
    background: []
  },
  responsive: {
    rules: []
  },
  legend: {
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'middle',
    itemMarginBottom: 12,
    enabled: true
  },
  yAxis: {
    title: {
      text: 'UU(人)'
    },
    labels: {}
  },
  xAxis: {
    labels: {
      style: {
        fontSize: '12px'
      }
    },
    title: {
      text: ''
    }
  },
  lang: {
    thousandsSep: ','
  }
}

export const option = {
  yAxis: {},
  // 讓三個數列的每個數值都不同色
  series: [
    {
      turboThreshold: 0,
      stack: 'TotalUU'
    },
    {
      turboThreshold: 0,
      stack: 'ReachUU'
    },
    {
      turboThreshold: 0,
      stack: 'TotalUU'
    },
    {
      turboThreshold: 0,
      stack: 'ReachUU'
    },
    {
      turboThreshold: 0,
      stack: 'TotalUU'
    },
    {
      turboThreshold: 0,
      stack: 'ReachUU'
    }
  ]
}
